// Shared shell for /privacy and /terms — no app chrome, just the wordmark and the document.
import { Link } from '@tanstack/react-router'
import { KbWordmark } from '#/components/shell/brand'
import { m } from '#/paraglide/messages'

const CONTACT_EMAIL = 'hello@bystep.dev'

export interface LegalSection {
  h: string
  p: string
}

export function LegalPage({ title, intro, sections, otherHref, otherLabel }: { title: string; intro: string; sections: LegalSection[]; otherHref: '/privacy' | '/terms'; otherLabel: string }) {
  return (
    <div className="flex min-h-0 flex-1 flex-col overflow-y-auto">
      <header className="px-6 py-5">
        <KbWordmark to="/" />
      </header>
      <main className="px-6 pb-16">
        <article className="mx-auto w-full max-w-3xl">
          <h1 className="font-heading text-3xl font-bold">{title}</h1>
          <p className="mt-1 text-sm text-muted-foreground">{m.legal_updated()}</p>
          <p className="mt-6 text-muted-foreground">{intro}</p>
          <ol className="mt-8 space-y-6">
            {sections.map((s, i) => (
              <li key={s.h}>
                <h2 className="font-heading text-lg font-semibold">
                  {i + 1}. {s.h}
                </h2>
                <p className="mt-1 leading-relaxed text-muted-foreground">{s.p}</p>
              </li>
            ))}
          </ol>
          <footer className="mt-10 flex flex-wrap items-center justify-between gap-3 border-t pt-6 text-sm text-muted-foreground">
            <span>
              {m.legal_contact({ email: '' })}
              <a className="underline" href={`mailto:${CONTACT_EMAIL}`}>
                {CONTACT_EMAIL}
              </a>
            </span>
            <Link className="underline" to={otherHref}>
              {otherLabel}
            </Link>
          </footer>
        </article>
      </main>
    </div>
  )
}
